// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { notebook16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-notebook': IconNotebook;
    }
}

/**
 * The icon component for the 'notebook' icon
 */
export class IconNotebook extends IconSvg {
    public constructor() {
        super(notebook16X16);
    }
}

registerIconSvg('icon-notebook', IconNotebook);
export const iconNotebookTag = 'nimble-icon-notebook';
